// @vue/component
export default {
  computed: {
    authRoutesQueryParams() {
      const {
        invitation_code, sent_invitation_uuid, redirect_to, client_uuid, location_uuid, // eslint-disable-line camelcase
      } = this.$route.query;

      return {
        invitation_code, sent_invitation_uuid, redirect_to, client_uuid, location_uuid,
      };
    },
    routes() {
      const routeNames = {
        emailVerification: 'email-verification',
        login: 'login',
        redirect: 'redirect',
        passwordReset: 'password-reset',
        passwordResetRequested: 'password-reset-requested',
        signup: 'signup',
      };
      const customConfig = {};
      const keys = Object.keys(routeNames);

      return _.zipObject(keys, keys.map(key => ({
        name: routeNames[key],
        query: this.authRoutesQueryParams,

        ...(customConfig[key] || {}),
      })));
    },
  },
};
